import { ISolicitation, IRequestSolicitationResponse, IRequestSolicitationRequest, IRequestSolicitationErrorResponse, IContact, IFindSolicitationErrorResponse, IFindSolicitationResponse, IRiskNvlData, StatusClient } from '../../models/solicitation-models/solicitation/SolicitationModel';
import { NavigationService } from '../navigation/navigation-service.service';
import { Injectable, QueryList } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from '../security/token.service';
import { LinkupService } from '../link-up/linkup.service';
import { findInArray, lastValueFrom, normalizeCryptoVaultSettings, recaptchaHeaders, setValueProperty } from '../../helpers/functions.helpers';
import { getValueProperty } from '../../helpers/functions.helpers';
import { EDocumentTypeId } from '../../../pages/form-solicitation-basic-data/form-solicitation-basic-data.component';
import { first, result } from 'lodash';
import { CatalogService } from '../catalogs/catalog.service';
import { IQueryParamsFindSolicitation } from './find-solicitations.service';
import * as queryString from 'query-string';
import { ApplicationService, EApplication } from '../application/application.service';
import { retry, catchError } from 'rxjs/operators';

export enum EDocumentTypes {
  DOCUMENT_TYPE_CC = 'CC',
  DOCUMENT_TYPE_CE = 'CE',
  DOCUMENT_TYPE_NIT = 'NT',
  DOCUMENT_TYPE_PA = 'PA',
  DOCUMENT_TYPE_TI = 'TI',
  DOCUMENT_TYPE_PD = 'PD'
}
@Injectable({
  providedIn: 'root'
})
export class RequestSolicitationsService {

  /**
   * @todo documentar
   */
  private _solicitation: ISolicitation;

  /**
   *
   */
  private _responseRequest?: IRequestSolicitationResponse | IRequestSolicitationErrorResponse | any;

  /**
   *
   */
  private _solicitationId: string | number;

  /**
   *
   */
  private _transactionCode: string | number;
  not_preset_gender: any;

  trys: number = 0;

  /**
   * Constructor de la clase RequestSolicitationsService
   */
  constructor(
    public navigation: NavigationService,
    private readonly _token: TokenService,
    private readonly _http: HttpClient,
    private readonly _link: LinkupService,
    private readonly _catalog: CatalogService,
    private _app: ApplicationService
  ) {
    this._solicitation = {} as ISolicitation;
    this._solicitationId = "";
    this._transactionCode = "";
  }

  /**
   * Permite guardar en memoria los datos del formulario para recuperarlos en pasos posteriores
   * @param form
   */
  set solicitation(value: ISolicitation) {
    this._solicitation = value;
  }

  /**
   *
   */
  get solicitation() {
    return this._solicitation;
  }

  /*
  * @todo documentar
  */
  get responseRequest(): IRequestSolicitationResponse | IRequestSolicitationErrorResponse {
    return this._responseRequest;
  }

  /**
   * @todo documentar
   */
  set responseRequest(value: IRequestSolicitationResponse | IRequestSolicitationErrorResponse) {
    this._responseRequest = value;
  }

  /*
  * @todo documentar
  */
  get solicitationId(): string | number {
    return this._solicitationId;
  }

  /**
   * @todo documentar
   */
  set solicitationId(value: string | number) {
    this._solicitationId = value;
  }

  /*
  * @todo documentar
  */
  get transactionCode(): string | number {
    return this._transactionCode;
  }

  /**
   * @todo documentar
   */
  set transactionCode(value: string | number) {
    this._transactionCode = value;
  }

  /**
   * Permite realizar la creación de una solicitud en el sistema
   * @param data
   * @returns
   */
  async send(data: IRequestSolicitationRequest, documentType: string, documentNumber: string, component = 'solicitation-detail'): Promise<any> {
    try {
      this.trys++;
      setValueProperty(this._solicitation.additionalData, "numberTrys", this.trys);
      const settings = await this._link.settings;
      const useCryptoVault = this._app.getSetting(getValueProperty(settings, `context.settings.${component}`), "services", "useCryptoVault", false);
      const contextUrls = await this._link.contextUrls;
      const URL = `${contextUrls.URLS.REQUEST_SOLICITATIONS}`;
      let documentTypeHeader = documentType;
      let httpOptions: { headers: HttpHeaders } = await this.httpOptions(documentTypeHeader, documentNumber);

      if (this._app.useRecaptcha && getValueProperty(settings, `request.REQUEST_SOLICITATIONS.recaptcha`, false)) {
        const recaptchaSettings = getValueProperty(settings, 'request.REQUEST_SOLICITATIONS.recaptcha', { options: {}, headers: {} });
        const captchaOptions = getValueProperty(recaptchaSettings, "options", { "action": "REQUEST_SOLICITATIONS" });
        httpOptions = await recaptchaHeaders(this._app, httpOptions, recaptchaSettings, captchaOptions);
      }

      if (useCryptoVault) {
        const transaction_id = await this._token.transactionId;
        await this._app.initCryptoVault(transaction_id);
        const cryptoVaultSettings = getValueProperty(settings, 'request.REQUEST_SOLICITATIONS.cryptoVault', { fields: [], headers: [] });

        let fieldsEncrypt = getValueProperty(cryptoVaultSettings, "fields", []);
        let headersEncrypt = getValueProperty(cryptoVaultSettings, "headers", []);
        data.data = await this._app.encrypt(data.data, fieldsEncrypt);
        httpOptions.headers = new HttpHeaders(await this._app.encrypt(httpOptions.headers, headersEncrypt, true));
        setValueProperty(data, 'data.crypto_vault', normalizeCryptoVaultSettings(this._app.normaliceCryptoVaultSettings({ ...cryptoVaultSettings })));
      }

      const req$ = this._http.post<IRequestSolicitationResponse>(URL, { ...data }, httpOptions);

      //.pipe(retry(getValueProperty(settings, `request.REQUEST_SOLICITATIONS.OPTIONS.retry`, 0)));

      const response: any = await lastValueFrom(req$);
      this.responseRequest = response;
      /**
       * @todo revisar interfaces y obtencion de solicitation_id, VALIDAR existencia de datos
       */
      const responseRequest = this.responseRequest as IRequestSolicitationResponse;
      this.solicitationId = getValueProperty(responseRequest, 'data.solicitation.solicitation_id', false);
      this.transactionCode = getValueProperty(responseRequest, 'data.solicitation.transaction_code', false);


      if (!this.solicitationId || !this.transactionCode) {
        throw new Error("No es posible procesar su solicitud");
      }

      this.trys = 0;

      return this.responseRequest;

    } catch (error) {

      const settings = await this._link.settings;
      const retry = getValueProperty(settings, `request.REQUEST_SOLICITATIONS.OPTIONS.retry`, 0);
      const timeRetry = getValueProperty(settings, `request.REQUEST_SOLICITATIONS.OPTIONS.timeRetry`, 2000);
      if (this.trys < retry) {
        await this.timeout(timeRetry);
        return await this.send(data, documentType, documentNumber, component);
      } else {
        console.log('error send', error);
        return {
          code: 'E002',
          message: 'Error al intentar crear la solicitud',
          numberTrys: this.trys
        } as IRequestSolicitationErrorResponse;
      }

    }
  }

  timeout(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Permite construir el objeto que sera envia al servicio de pqr
   * @param data
   * @returns
   */
  async buildData(data: ISolicitation, component = 'solicitation-detail'): Promise<IRequestSolicitationRequest> {

    const CHANNEL_ID = `${getValueProperty(this._app, 'channelId', '159')}`;
    const CHANNEL_NAME = `${getValueProperty(this._app, 'channelName', 'Operador Portal')}`;
    const settings = await this._link.settings;
    const useRiskLevelData = this._app.getSetting(getValueProperty(settings, `context.settings.${component}`), "services", "request_risk_level", true);
    const sessionData = this._token.userData;
    const default_risk_level_code = this._app.getSetting(getValueProperty(settings, `context.settings.${component}`), "services", "defaultData.risk_level_code", "4");
    const default_client_status = this._app.getSetting(getValueProperty(settings, `context.settings.${component}`), "services", "defaultData.client_status", "0");

    const documentType = getValueProperty(data.basicData, 'document_type', '');

    const solicitationSubsegment = await this._catalog.getSubsegmentById(getValueProperty(data.basicData, 'subsegment', ''));
    const solicitationSegment = await this._catalog.getSegmentById(getValueProperty(data.basicData, 'segment', ''));
    const solicitationSubtype = await this._catalog.getCelulaTypeSubtypeById(getValueProperty(data.additionalData, 'SolicitationSubtype', ''));
    const solicitationType = await this._catalog.getCelulaTypeById(getValueProperty(data.additionalData, 'SolicitationType', ''));

    let names: string = getValueProperty(data.basicData, 'client_names', '');
    let surnames: string = getValueProperty(data.basicData, 'client_surnames', '');

    if (this._app.currentApplication === EApplication.FIDUCIAL) {
      names = getValueProperty(data, 'contactsData.contacts.0.names', 'Titular');
      surnames = getValueProperty(data, 'contactsData.contacts.0.surnames', 'del Fideicomiso');
    }

    let arrayNames = names.split(' ');
    let arraySurnames = surnames.split(' ');

    let firstName = '';
    let givenName = '';
    let firstSurname = '';
    let secondSurname = '';
    let userUserType = 'Natural';
    let userUserId = '1';
    let fullName = '';

    let _genderList = await this._catalog.genders;



    if (documentType === EDocumentTypeId.NIT || documentType === EDocumentTypeId.SE) {
      userUserType = "Jurídica";
      userUserId = "2";
      firstName = arrayNames.shift() || '';
      firstSurname = arrayNames.join(' ') || '';
      fullName = `${names}`.trim();
    } else {
      firstName = arrayNames.shift() || '';
      givenName = arrayNames.join(' ') || '';
      firstSurname = arraySurnames.shift() || '';
      secondSurname = arraySurnames.join(' ') || '';
      fullName = `${names} ${surnames}`.trim();
    }
    let additionalInformation = '';
    if (useRiskLevelData) {
      additionalInformation = this.toStringrisk(data);
    }
    additionalInformation += getValueProperty(data.risknvlData, 'annotations_error', '') + ";" + `${getValueProperty(data.additionalData, 'Annotations', '')}`
    let moment = require('moment');
    moment.updateLocale(moment.locale(), { invalidDate: '' });
    let dataBuild: IRequestSolicitationRequest = {
      data: {
        solicitation: {
          document: {
            typeId: `${getValueProperty(data.basicData, 'document_type', '')}`, //Pendiente implementacion
            type: `${getValueProperty(data.basicData, 'document_type_desc', '')}`,
            number: `${getValueProperty(data.basicData, 'document_number', '')}`,
            id: `${getValueProperty(data.basicData, 'client_id', '')}`,
            user_type: `TT`
          },
          complain: {
            channel_id: CHANNEL_ID,
            channel_name: CHANNEL_NAME,
            complain_form: " ",
            complain_desc: "Radicacion solicitud; " + `${getValueProperty(solicitationType, 'name', '')}; ` + `${getValueProperty(solicitationSubtype, 'name', '')}; Creado por: ${getValueProperty(sessionData, 'names', '')} ${CHANNEL_ID} ${CHANNEL_NAME};`
          },
          user: {
            name: fullName,
            first_name: `${firstName}`,
            given_name: `${givenName}`,
            first_surname: `${firstSurname}`,
            second_surname: `${secondSurname}`,
            user_type: userUserType,//"Natural" "Juridico",
            user_id: userUserId, //"1" ->Nat "2" -> Jur
            age: ``,
            email: `${getValueProperty(data.contactsData, 'contact_primary.email', 'no@email.com')}`,
            segment: {
              segment_id: `${getValueProperty(solicitationSegment, 'id', '0')}`,
              segment_name: `${getValueProperty(solicitationSegment, 'name', '')}`
            },
            sub_segment: {
              sub_segment_id: `${getValueProperty(solicitationSubsegment, 'id', '0')}`,
              sub_segment_name: `${getValueProperty(solicitationSubsegment, 'name', '')}`
            }
          },
          phones: [],
          address: {
            district_code: `${getValueProperty(data.basicData, 'state', '')}`, //-> codigo departamento
            city_code: `${getValueProperty(data.basicData, 'city', '')}`, //-> codigo ciudad
            portal_code: `${getValueProperty(data.basicData, 'city', '0')}`, //-> codigo ciudad
            street: `${getValueProperty(data.basicData, 'address', '')}`, // Dirección
            country: 'COL'//        -> "COL"
          },
          contacts: [],
          solicitation_originator: " ",
          admission: " ",//"Queja o reclamo admitida por el DCF", //validar
          acceptance: "",//"Respuesta final a favor del consumidor financiero aceptadas por la entidad",
          correction: "",//"Respuesta final a favor del consumidor financiero aceptadas por la entidad",
          solicitation_reason: "",
          relation_control_entity: "No",
          control_entity: "No",
          control_entity_id: " ",
          control_area: "",
          time_solution: "",
          expiration_date: "",
          guardianship_flag: false,
          escalation_flag: false,
          withdrawal_flag: false,
          replica_flag: false,
          solicitation_argument: "No",
          new_contacts_flag: false,
          solicitation: "Radicacion solicitud",
          solicitation_description: ` `, //validar obligatoriedad
          solicitation_category: `${getValueProperty(solicitationSubtype, 'id', '0')}`, //-> tipo_solicitud -> paso 3
          solicitation_category_name: `${getValueProperty(solicitationType, 'name', '')}`,
          solicitations: [
            {
              solicitation_subtype: `${getValueProperty(solicitationSubtype, 'id', '0')}`, //-> subtipo_solicitud -> paso 3
              solicitation_subtype_name: `${getValueProperty(solicitationSubtype, 'name', '')}`,
              origin_amount: {
                amount: `${getValueProperty(data.additionalData, 'SolicitationValue', '0.00')}`.replace('.', ''), //-> Solicitation_value -> paso 3 -> replace (.) por vacio
                currency: 'COP', //-> COP
                decimals: '2' // -> 2
              }
            }
          ],
          solicitation_activity: `${getValueProperty(data.basicData, 'economic_activity', '0')}`, //-> obligatorio validar
          branch_id: `${getValueProperty(data.basicData, 'originator_branch', '0')}`,
          employee: {
            //Comercial especializado
            employee_product_name: `${getValueProperty(data, 'contactsData.SA_Names', '')}`,
            phone_product_num: {
              phone: `${getValueProperty(data, 'contactsData.SA_Phone', '')}`,
            },
            email_product_addr: `${getValueProperty(data, 'contactsData.SA_Email', '')}`,
            //Comercial asignado
            employee_name: `${getValueProperty(data, 'contactsData.CA_Names', '')}`,
            phone_num: {
              phone: `${getValueProperty(data, 'contactsData.CA_Phone', '')}`,
            },
            email_addr: `${getValueProperty(data, 'contactsData.CA_Email', '')}`,
            user_name: `${getValueProperty(sessionData, 'document_number', '')}_${getValueProperty(sessionData, 'names', '')}`, ///validar con sebas
          },
          product: {
            product_name: "Otro",
            product_id: "10",
            product_client_id: "0"
          },

          gender_id: getValueProperty(data, 'basicData.gender', this.not_preset_gender),
          gender: getValueProperty(findInArray(_genderList, 'id', getValueProperty(data, 'basicData.gender', this.not_preset_gender)), 'name', ''),
          gender_flag: false,
          special_condition: "No aplica",
          special_condition_id: "98",
          email_flag: false,
          phone_flag: false,
          person_flag: false,
          additional_information: additionalInformation,
          solicitation_cell: getValueProperty(data.additionalData, 'Cell.id', ''),
          solicitation_cell_name: getValueProperty(data.additionalData, 'Cell.name', ''),
          solicitation_application: this._app.currentApplication,
          /**Pendiente implementacion */
          binding_date: moment.utc(getValueProperty(data.risknvlData, 'start_date', '')).format("DD/MM/YYYY"),
          last_update_date: moment.utc(getValueProperty(data.risknvlData, 'last_update_date', '')).format("DD/MM/YYYY"),
          risk_last_update_date: moment.utc(getValueProperty(data.risknvlData, 'last_update_risk_date', '')).format("DD/MM/YYYY"),
          max_update_date: moment.utc(getValueProperty(data.risknvlData, 'update_maximun_date', '')).format("DD/MM/YYYY"),
          client_status_flag: getValueProperty(data.risknvlData, 'client_status', default_client_status),
          risk_level_id: getValueProperty(data.risknvlData, 'risk_level_code', default_risk_level_code),
          business_relationship: `${getValueProperty(data.contactsData, 'CA_Code', '')}`,
          product_relationship: `${getValueProperty(data.contactsData, 'CA_CodeProduct', '')}`,
        }
      }
    };


    if (documentType === EDocumentTypeId.NIT || documentType === EDocumentTypeId.SE) {
      setValueProperty(dataBuild, 'data.solicitation.legal_person', `${getValueProperty(data.basicData, 'client_names', '')}`); //-> Razon social -> opcional
      setValueProperty(dataBuild, 'data.solicitation.document.nit', `${getValueProperty(data.basicData, 'document_number', '')}`);
      setValueProperty(dataBuild, 'data.solicitation.document.type_code', `${getValueProperty(data.basicData, 'document_type', '')}`);
    }

    const contactsData: {
      contact_primary: IContact,
      contact_additional: IContact
    } = getValueProperty(data, 'contactsData', {});

    let countContacts = 0;
    let countAddNewContacts = 0;

    if (getValueProperty(contactsData, 'contact_primary', false)) {
      let contact = getValueProperty(contactsData, 'contact_primary');
      if (!contact.contact_exist) {
        countAddNewContacts++;
      }
      this.addContact(contact, dataBuild, countAddNewContacts, countContacts);
      countContacts++;
    }

    if (getValueProperty(contactsData, 'contact_additional', false) && getValueProperty(contactsData, 'contact_additional.phone_1', false)) {
      let contact = getValueProperty(contactsData, 'contact_additional');
      if (!contact.contact_exist) {
        countAddNewContacts++;
      }
      this.addContact(contact, dataBuild, countAddNewContacts, countContacts);
      countContacts++;
    }

    /**
     * Actualizamos bandera creacion nuevos contactos
     */
    setValueProperty(dataBuild, 'data.solicitation.new_contacts_flag', (countAddNewContacts > 0));

    return dataBuild;
  }

  addContact(contact: IContact, dataBuild: any, countAddNewContacts: number, countContacts: number) {

    let contactBuild = {
      email: contact.email,
      user_name: `${getValueProperty(contact, 'names', '')}${getValueProperty(contact, 'surnames', '')}`,
      phones: [
        {
          phone_number: contact.phone_1
        }
      ]
    };

    if (countContacts === 0) {
      dataBuild.data.solicitation.phones.push({
        phone_type: "Movil_Principa",
        phone_number: contact.phone_1
      });
    }

    if (countContacts === 1) {
      dataBuild.data.solicitation.phones.push({
        phone_type: "Phone1",
        phone_number: getValueProperty(contact, 'phone_1', '0000')
      });
    }

    dataBuild.data.solicitation.contacts.push(contactBuild);

  }

  /**
   * Ajustes reinicio proceso de radicacion solicitud
   */
  reset() {
    this._solicitation = {} as ISolicitation;
    this._solicitationId = '';
    this._token.loadTransactionId();
  }

  toStringrisk(data: ISolicitation) {
    const CHANNEL_ID = `${getValueProperty(this._app, 'channelId', '159')}`;
    const CHANNEL_NAME = `${getValueProperty(this._app, 'channelName', 'Operador Portal')}`;
    let cadena = `Creado por: ${getValueProperty(this._token.userData, 'names', '')};`;
    if (data.basicData?.customer_exists) {
      let moment = require('moment');
      moment.updateLocale(moment.locale(), { invalidDate: 'Fecha incorrecta ó no definida' });
      cadena += getValueProperty(data.risknvlData, 'client_status', '') == StatusClient.actualizado ? "0-Cliente Actualizado" :
        getValueProperty(data.risknvlData, 'client_status', '') == StatusClient.proximo_a_desactualizar ? "1-Cliente Próximo a desactualizarse" :
          getValueProperty(data.risknvlData, 'client_status', '') == StatusClient.desactualizado ? "2-Cliente desactualizado" : "3-Fallo en Servicio";
      cadena += ";Nivel de riesgo: " + (
        getValueProperty(data.risknvlData, 'risk_level_code', '') == '1' ? "1-Bajo" :
          getValueProperty(data.risknvlData, 'risk_level_code', '') == '2' ? "2-Medio" :
            getValueProperty(data.risknvlData, 'risk_level_code', '') == '3' ? "3-Alto" :
              getValueProperty(data.risknvlData, 'risk_level_code', '') == "0" ? "0-No tiene nivel de riesgo" : "4-Fallo en Servicio");
      if (getValueProperty(data.risknvlData, "risk_level_code") != 4 && getValueProperty(data.risknvlData, "client_status") != 3) {
        cadena += ";fecha máxima actualización: " + moment.utc(getValueProperty(data.risknvlData, 'last_update_date', '')).format("DD/MM/YYYY");
        cadena += ";fecha ultima actualización: " + moment.utc(getValueProperty(data.risknvlData, 'last_update_risk_date', '')).format("DD/MM/YYYY");
        cadena += ";fecha de vinculación: " + moment.utc(getValueProperty(data.risknvlData, 'start_date', '')).format("DD/MM/YYYY");
        cadena += ";fecha ultima actualización nivel de riesgo: " + moment.utc(getValueProperty(data.risknvlData, 'update_maximun_date', '')).format("DD/MM/YYYY");
      }
      cadena += ` ${CHANNEL_ID} ${CHANNEL_NAME};`;
    }
    return cadena;
  }

  /**
   * Permite construir de manera dinamica los encabezados para las peticiones al servicio de solicitudes
   */
  async httpOptions(documentType: string, documentNumber: string) {
    const { accessToken } = await this._token.accessToken;
    const transaction_id = await this._token.transactionId;
    const session_id = await this._token.sessionId;
    return {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${accessToken}`)
        .set('token-client-id', `${documentNumber}_${documentType}`)
        .set('application', this._app.application)
        .set('channel-id', this._app.channelId)
        .set('session_id', session_id)
        .set('terminal_id', '127.0.0.1')
        .set('timestamp', new Date().toISOString())
        .set('transaction_id', transaction_id)
        .set('Content-Type', 'application/json; charset=utf-8')
    };
  }

  /**
* Permite realizar la consulta de solicitudes duplicadas de un cliente en el sistema
* @param data
* @returns
*/
  async getDuplicity(data: IQueryParamsFindSolicitation, component = 'form-solicitation-additional-data') {
    try {
      const settings = await this._link.settings;
      const useCryptoVault = this._app.getSetting(getValueProperty(settings, `context.settings.${component}`), "services", "useCryptoVault", false);
      data.solicitation_id = getValueProperty(settings, `request.FIND_SOLICITATIONS.queryType.${getValueProperty(data, 'query_type')}.solicitation_id`, "");
      data.solicitation_application = this._app.currentApplication;
      const documentType = getValueProperty(data, "document_type", "");
      const documentNumber = getValueProperty(data, "document_number", "");
      const contextUrls = await this._link.contextUrls;
      let URL_BASE = `${contextUrls.URLS.FIND_DUPLICITY}`;
      let URL = URL_BASE;
      let httpOptions: any = await this.httpOptions(documentType, documentNumber);


      if (this._app.useRecaptcha && getValueProperty(settings, `request.FIND_DUPLICITY.recaptcha`, false)) {
        const recaptchaSettings = getValueProperty(settings, `request.FIND_DUPLICITY.recaptcha`, { options: {}, headers: {} });
        const captchaOptions = getValueProperty(recaptchaSettings, "options", { "action": `FIND_DUPLICITY` });
        httpOptions = await recaptchaHeaders(this._app, httpOptions, recaptchaSettings, captchaOptions);
      }

      if (useCryptoVault) {
        const transaction_id = await this._token.transactionId;
        await this._app.initCryptoVault(transaction_id);
        const cryptoVaultSettings = getValueProperty(settings, 'request.FIND_DUPLICITY.cryptoVault', { fields: [], headers: [] });
        data = await this._app.encrypt(data, getValueProperty(cryptoVaultSettings, "fields", []));
        httpOptions.headers = new HttpHeaders(await this._app.encrypt(httpOptions.headers, getValueProperty(cryptoVaultSettings, "headers", []), true));
        data.crypto_vault = normalizeCryptoVaultSettings(cryptoVaultSettings);
      }
      const req$ = this._http.post<any>(URL, { data: { ...data } }, httpOptions);
      const response: any = await lastValueFrom(req$);
      this.responseRequest = response;
      if (useCryptoVault && getValueProperty(response, 'data.message', false)) {
        let encryptData = getValueProperty(response, 'data.message');
        if (encryptData) {
          let responseData = await this._app.decrypt(encryptData);
          try {
            this.responseRequest = JSON.parse(responseData);
          } catch (error) {
            console.log('error', error);
          };
        }
      }
      return this.responseRequest;
    } catch (error) {
      return {
        code: 'E002',
        message: 'Error al intentar consultar las solicitudes'
      } as IFindSolicitationErrorResponse;
    }
  }

}

